module.exports = __webpack_public_path__ + "static/media/Sample-Purchase-Order.0efd5258.xlsx";